import { defineMessages } from '@/i18n';

export const sideNavMessages = defineMessages({
  activation: 'platform.app.gallery.activation.title',
  inventory: 'platform.app.gallery.artworks.title',
  collection: 'platform.app.gallery.artworks.titleBuyer',
  account: 'platform.app.side-nav.account',
  admin: 'platform.app.side-nav.admin',
  emails: 'platform.app.side-nav.emails',
  userAccess: 'platform.app.side-nav.userAccess',
  help: 'platform.app.side-nav.help',
  support: 'platform.app.side-nav.support',
  terms: 'platform.app.side-nav.terms',
  privacy: 'platform.app.side-nav.privacy',
  purchases: 'platform.app.side-nav.purchases',
  purchasesRequests: 'platform.app.side-nav.purchases.requests',
  purchasesSalesAgreementsAndTransfers: 'platform.app.side-nav.purchases.sales-agreements-and-transfers',
  sales: 'platform.app.side-nav.sales',
  salesRequests: 'platform.app.side-nav.sales.requests-received',
  salesSalesAgreementsAndTransfers: 'platform.app.side-nav.sales.sales-agreements-and-transfers',
  salesStorefronts: 'platform.app.side-nav.sales.storefronts',
  salesStorefrontsAndRooms: 'platform.app.side-nav.sales.storefrontsAndRooms',
  salesStorefrontsAndRoomsArtBasel: 'platform.app.side-nav.sales.storefrontsAndRoomsArtBasel',
  dashboard: 'platform.app.side-nav.dashboard',
  accountPreferences: 'platform.app.side-nav.accountPreferences',
  accountSettings: 'platform.app.side-nav.accountSettings',
  subscription: 'platform.app.side-nav.subscription',
  mySettings: 'platform.app.side-nav.mySettings',
  accountPayments: 'platform.app.side-nav.accountPayments',
  accountTeam: 'platform.app.side-nav.accountTeam',
  linkInBio: 'platform.app.side-nav.linkInBio',
  idScanner: 'platform.app.side-nav.idScanner',
});
